import {
    ADD,
    ADD_FAILURE,
    ADD_SUCCESS,
    DELETE,
    DELETE_FAILURE,
    DELETE_SUCCESS,
    EDIT,
    EDIT_FAILURE,
    EDIT_SUCCESS,
    GET_ALL,
    GET_ALL_FAILURE,
    GET_ALL_SUCCESS,
    GET,
    GET_FAILURE,
    GET_SUCCESS,
} from "./actionTypes";

const initialState = {
    themes: {},
    loading: false,
    error: "",
    singleTheme: {},
};

const stores = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL:
            state = {
                ...state,
                error: "",
                loading: true,
            };
            break;
        case GET_ALL_SUCCESS:
            state = {
                ...state,
                error: "",
                loading: false,
                themes: action.payload,
            };
            break;

        case GET_ALL_FAILURE:
            state = { ...state, error: action.payload, loading: false };
            break;

        case ADD:
            state = {
                ...state,
                error: "",
                loading: true,
            };
            break;

        case ADD_SUCCESS:
            state = {
                ...state,
                error: "",
                loading: false,
                singleTheme: action.payload.theme,
            };
            break;

        case ADD_FAILURE:
            state = { ...state, error: action.payload, loading: false };
            break;

        case GET:
            state = {
                ...state,
                error: "",
                loading: true,
                singleTheme: {},
            };
            break;

        case GET_SUCCESS:
            state = {
                ...state,
                error: "",
                loading: false,
                singleTheme: action.payload.theme,
            };
            break;

        case GET_FAILURE:
            state = { ...state, error: action.payload, loading: false };
            break;

        case EDIT:
            state = {
                ...state,
                error: "",
                loading: true,
                singleTheme: {},
            };
            break;

        case EDIT_SUCCESS:
            state = {
                ...state,
                error: "",
                loading: false,
                singleTheme: action.payload?.theme,
            };
            break;

        case EDIT_FAILURE:
            state = { ...state, error: action.payload, loading: false };
            break;

        case DELETE:
            state = {
                ...state,
                error: "",
                loading: true,
                singleTheme: {},
            };
            break;

        case DELETE_SUCCESS: {
            const afterDeleteing = state?.themes
                ? state?.themes?.filter((type) => type?.id !== action.payload)
                : [];
            state = {
                ...state,
                error: "",
                loading: false,
                themes: afterDeleteing,
            };
            break;
        }

        case DELETE_FAILURE:
            state = { ...state, error: action.payload, loading: false };
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
};

export default stores;
